import { configFetch as fetch } from '@meiqia/utils';
import { getLocalCheckedAgent } from 'chat/api/operate-data';

// 我的对话列表
export const getMeConversationsApi = () => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/conversation/agent/active',
      method: 'get'
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        const { conversations } = data;
        resolve({ data: conversations });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 机器人未识别
export const getUnrecognizedConversationApi = ({ agent_id }) =>
  fetch({
    url: '/conversation/agent/trusteeship',
    method: 'get',
    params: {
      agent_id
    }
  });

// 同事的对话列表
export const getColleaguesConversationsApi = ({ cursor, limit, entId } = { cursor: -1, limit: 15 }) => {
  const data = {
    cursor,
    limit,
    ent_id: entId
  };
  const agent_ids = getLocalCheckedAgent();
  if (agent_ids?.length) data.agent_ids = agent_ids;
  return new Promise((resolve, reject) => {
    fetch({
      url: '/conversation/agent/colleagues/v2',
      method: 'post',
      data
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        const { conversations, has_next, next_cursor } = data;
        resolve({ data: conversations, hasNext: has_next, nextCursor: next_cursor });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 获取提到我的对话列表
export const getAtMeConversationsApi = agentId => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/agent/agents/${agentId}/mentioned_convs`,
      method: 'get'
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve({ data: data.convs });
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const getAllConversationsApi = ({ entId, offset_token, rules } = { rules: [], offset_token: '' }) => {
  // 获取全部对话的接口
  const data = {
    ent_id: entId,
    offset_token,
    rules
  };
  return new Promise((resolve, reject) => {
    fetch({
      // url: '/users/new/search/next',
      url: '/unified-api/crm/v1/users/new/search/next',
      method: 'post',
      data
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        const { users, offset_token, total } = data;
        resolve({ users, offset_token, total });
      })
      .catch(e => {
        reject(e);
      });
  });
};
